import React, { Fragment } from "react";
import Header from "../components/Header";
import PageHeader from "../components/PageHeader";
import About from "../components/About/page";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import SEO from "../components/SEO";

const PageAbout = () => {
  return (
    <Fragment>
      <Header />
      <SEO />

      {/* <PageHeader
        bgImg={require("../assets/img/about/about-head-bg.jpg")}
        title="Kangaroo Care - Leading Women & Children Care Hospitals"
        content=""
      /> */}
      <About
        // title={"About Us"}
        heading=" <span class='about-title basefont-strong'>Kangaroo Care for you & your baby</span>"
        alt="Lab technician testing in laboratory"
        image1={require("../assets/img/gallery/mom-baby.jpg")}
        // content="<div class='about-main'>At  Kangaroo Care, we see a child as life's greatest gift and pregnancy as a magical experience</div> "
        content1="<p><strong>Nurturing Care for You and Your Baby</strong></p><p>During your pregnancy, you deserve love, care, and exceptional medical support. At Kangaroo Care, we remain dedicated to providing expert medical assistance, advanced facilities, and a nurturing environment that prioritizes the well-being of both you and your baby.</p><p><strong>Why Choose Us?</strong></p><p>
        <ul><li><strong>Expert Medical Team: </strong>Our professionals offer personalized care.</li><li><strong>Advanced Facilities: </strong>Equipped with the latest technology to ensure a secure and soothing environment.</li><li><strong>Holistic Approach: </strong>Prenatal education and emotional support available.</li><li><strong>Supportive Community: </strong>We are here for you during your journey.</li></ul></p><p><strong>Choose Kangaroo Care Hospitals for a joyful pregnancy</strong>.</p>"
        classes="ts10"
      />
      {/* <About
        title=""
        heading="  <span class='basefont-strong'>Our Vision &</span>  <span class='basefont-strong'> Mission</span> "
        thumb={require("../assets/img/about/vission-mission-2.jpg")}
        alt="Happy mother and baby looking at each other"
        content={`<div class='container'>
         
          <div class='row ts30'>
            <div class='col-md-6 col-sm-12 '>
                <p><strong class='basefont-strong'>Vision:</strong> "We at Kangaroo Care would like to be India's most trusted brand in the field of women and child health"</p>
            </div>
            <div class='col-md-6 col-sm-12'>
              <p><strong class='basefont-strong'>Mission:</strong> "At Kangaroo Care, we believe in high quality of affordable care for women and babies in safe, friendly and caring environment"</p>
            </div>
          </div>
          
               
        </div>
        `}
        orderImg="1"
        orderContent="0"
        classes="about-page-section-two ts10"
      /> */}
      <div class="row container-fluid vision-section py-5 my-5">
        <div class="col-md-4 px-4">
          <h4 class="section-title1">
            OUR <span class="highlight">VISION</span>
          </h4>
          <div class="underline"></div>
          <p>
            We at Kangaroo Care would like to be India's most trusted brand in
            the field of women and child health.
          </p>
        </div>

        <div class="col-md-4 px-4">
          <h4 class="section-title1">
            OUR <span class="highlight">MISSION</span>
          </h4>
          <div class="underline"></div>
          <p>
            At Kangaroo Care, we believe in high quality of affordable care for
            women and babies in a safe, friendly and caring environment.
          </p>
        </div>

        <div class="col-md-4 px-4">
          <h4 class="section-title1">
            OUR <span class="highlight">QUALITY</span>
          </h4>
          <div class="underline"></div>
          <p>
            We strive for exceptional performance by nurturing a relentless
            dedication to quality improvement in every domain, with a strong
            focus on keeping patient safety as our foremost concern.
          </p>
        </div>
      </div>
      {/* <About
        title=""
        heading="<span class='basefont-strong'> Core Values</span>"
        thumb={require("../assets/img/about/vission-mission-3.jpeg")}
        alt="Pregnant Women sitting on sofa holding fruit bowl"
        content={`
        <ul class="about-page-ul">
            <li>Ethical conduct</li>
            <li>Professional integrity and transparency</li>
            <li>Patient-centric quality care with commitment and compassion.</li>
            <li>We believe in following standards and protocols to ensure that all the patients get the Best Results.</li>
            <li>We aim to be a leading source of the research center and pass the benefit to patients with the newer advances and strive for continuous improvement.</li>
            <li>We will be a learning hospital where we educate and empower the next generation healthcare professionals to become leaders in Women and Children health care to their full potential.</li>
            <li>Accountability: Strict financial control which is based on uncompromising honesty so that we achieve our higher purpose.</li>
        </ul>
        `}
        classes="bs100 ts10"
      /> */}
      <Footer />
      <MobileMenu />
    </Fragment>
  );
};
export default PageAbout;
